import React, { useEffect, useRef } from "react";
import { IcAnterior, IcSiguiente } from "./player-components/IconosPlayer";
import './controles.css';

export default function EscenasMenu({ escenas, setEscena, hiddenScenasShortcut, escenaIndex }){
    const carouselRef = useRef(null);
    const listaRef = useRef(null);

    useEffect(() => {
        const handleOutsideTouch = (event) => {
            //el botón de escenas abre y cierra el carrusel por su cuenta: si lo cerramos acá, el
            //toque que sigue lo vuelve a abrir
            if (event.target.closest && event.target.closest('#menuFlotanteEscenas')) return;
            if (carouselRef.current && !carouselRef.current.contains(event.target)) {
                hiddenScenasShortcut();
            }
        };
        document.addEventListener('touchstart', handleOutsideTouch);
        return () => document.removeEventListener('touchstart', handleOutsideTouch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //la escena actual siempre a la vista al abrir el carrusel
    useEffect(() => {
        const lista = listaRef.current;
        const actual = lista && lista.querySelector('[aria-current="true"]');
        if (actual) lista.scrollLeft = Math.max(0, actual.offsetLeft - lista.offsetLeft - 8);
    }, [escenaIndex, escenas]);

    const setScroll = (right) => {
        const lista = listaRef.current;
        if (!lista) return;
        lista.scrollBy({ left: (right ? 1 : -1) * lista.clientWidth * 0.8, behavior: 'smooth' });
    };

    return (
        <div
            ref={carouselRef}
            id="escenasContainer"
            className="p360-vidrio hidden-scenes"
            role="region"
            aria-label="Escenas"
            onMouseLeave={hiddenScenasShortcut}
        >
            <div className="navigation-controls">
                <button type="button" className="p360-btn p360-vidrio" aria-label="Escenas anteriores"
                    onClick={(e) => { e.stopPropagation(); setScroll(false); }}>
                    <IcAnterior />
                </button>
            </div>
            <div id="escenasMenu" ref={listaRef}>
                {escenas && escenas.map((e, i) =>
                    <button
                        type="button"
                        key={i}
                        className="escenaIcon"
                        aria-current={i === escenaIndex}
                        title={e.titulo}
                        onClick={() => setEscena(e.titulo)}
                    >
                        <img className="escenaPic" src={e.fondo} alt="" loading="lazy" />
                        <span>{e.titulo}</span>
                    </button>
                )}
            </div>
            <div className="navigation-controls">
                <button type="button" className="p360-btn p360-vidrio" aria-label="Escenas siguientes"
                    onClick={(e) => { e.stopPropagation(); setScroll(true); }}>
                    <IcSiguiente />
                </button>
            </div>
        </div>
    );
}
